/**
 * @prettier
 */

export const KEY_NAME = 'customAlertShown';

export function setIsCustomAlertBeingShownInLocalStorage(value: boolean): void {
    window.localStorage.setItem(KEY_NAME, JSON.stringify(!!value));
}
